<template>
  <v-container>
    <div class="px-4 py-6">

      <v-row class="mb-6">

        <v-col cols="12" class="pa-3 mb-4">
          <v-card  elevation="0">
            <v-img src="@/assets/images/cdv-home-banner.png" max-width="100%" contain></v-img>
          </v-card>
        </v-col> 
              
        <v-col cols="12">
          <v-card outlined class="pa-6 header-unified-card">
            <v-row align="center" justify="space-between">

              <v-col cols="12" md="5" class="text-center text-md-left">
                <div class="welcome-section">
                  <div class="text-h5 font-weight-bold primary--text d-flex align-center justify-center justify-md-start">
                    Olá, {{ this.auth.user.name }}
                    <v-btn icon small to="/conta/configuracoes/dados-pessoais?cdv" class="ml-2">
                      <v-icon small color="primary">mdi-pencil</v-icon>
                    </v-btn>
                  </div>
                  <div style="font-size: 1em;" class=" mt-1 grey--text text--darken-1">Acesso desde {{
                    formattedSinceDate }}</div>
                </div>
              </v-col>


              <v-col cols="12" md="2" class="text-center">
                <div class="logo-section">
                  <v-img :src="getLogo()" max-width="150" max-height="80" contain class="mx-auto">
                  </v-img>
                </div>
              </v-col>


              <v-col cols="12" md="5" class="text-center text-md-right">
                <div class="premium-section">
                  <div class="d-flex align-center justify-center justify-md-end">
                    <div>

                         <div style="font-size: 1.1em;" class=" font-weight-bold primary--text">{{ this.auth.profile.displayName }}</div>
                           <div style="font-size: 1em;" class="mt-1 grey--text text--darken-1">{{ this.auth.profile.name }}</div>
                           <div style="font-size: .8em;" v-if="profileAssoc() !== 0" class=" mt-1 grey--text text--darken-1">
                             <v-tooltip 
                               v-model="showProfileTooltip"
                               right
                               :disabled="false"
                               manual
                               content-class="custom-tooltip">
                               <template v-slot:activator="{ attrs }">
                                 <span 
                                   v-bind="attrs" 
                                   @click="toggleProfileTooltip" 
                                   style="cursor: pointer; text-decoration: underline;"
                                   class="hover-underline">
                                   <strong>{{ profileAssoc() }}</strong>
                                 </span>
                               </template>
                               <div>
                                 <v-card-title class="text-body-1 font-weight-bold pa-3 pb-2 d-flex justify-space-between align-center">
                                   <span class="mr-3">Perfis Associados</span>
                                   <v-btn 
                                     icon 
                                     x-small 
                                     @click="showProfileTooltip = false">
                                     <v-icon small>mdi-close</v-icon>
                                   </v-btn>
                                 </v-card-title>
                                 <v-card-text class="pa-3 pt-2">
                                   <div class="text-body-2">
                                     <ul style="padding-left: 1em; margin: 0;"> 
                                       <li v-for="profile in getVehicleProfiles()" :key="profile.document" style="font-size: 0.95em; margin-bottom: 4px;">
                                         <strong>{{ profile.displayName }}</strong>
                                       </li>
                                     </ul>
                                   </div>
                                 </v-card-text>
                               </div>
                             </v-tooltip>
                             <v-btn 
                               icon 
                               small 
                               to="/app/management/profiles"
                               color="primary"
                               class="ml-2">
                               <v-icon small>mdi-open-in-new</v-icon>
                             </v-btn>
                           </div>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>


      <v-row class="mb-6">

        <v-col cols="12" md="4">
          <v-card outlined class="notification-card" :loading="financial.loading">
            <div class="card-content pa-4">
              <div class="text-h6 text-center primary--text font-weight-bold">Financeiro</div>
              
              <div v-if="financial.firstDate" class="text-body-2 my-2 text-center grey--text">
                <v-icon small color="primary" class="mr-1">mdi-calendar</v-icon>
                Desde {{ formatDate(financial.firstDate) }}
              </div>
              
              <v-divider></v-divider>
              
              <div class="d-flex justify-space-between align-center mb-2">
                <span class="text-body-2 grey--text text--darken-2">PIs Emitidas:</span>
                <v-chip color="primary" text-color="white" small>
                  <strong>{{ financial.totalPis }}</strong>
                </v-chip>
              </div>
              
              <div class="d-flex justify-space-between align-center">
                <span class="text-body-2 grey--text text--darken-2">Valor Total:</span>
                <span class="text-body-1 green--text text--darken-2 font-weight-bold">
                  {{ formatCurrency(financial.totalNetPrice) }}
                </span>
              </div>
              
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" md="4">
          <v-card outlined class="pa-4 notification-card disabled-card">
            <div class="wip-badge">
              <v-chip color="light-blue lighten-3" text-color="white" small>EM BREVE</v-chip>
            </div>
            <div class="card-content">
              <div class="text-body-1 mb-3 text-center disabled-text">{{ pendingQuotes.message }}</div>
              <v-btn text color="grey" class="pa-0 disabled-btn" disabled style="text-transform: none;">
                {{ pendingQuotes.action }} →
              </v-btn>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" md="4">
          <v-card outlined class="pa-4 notification-card disabled-card">
            <div class="wip-badge">
              <v-chip color="light-blue lighten-3" text-color="white" small>EM BREVE</v-chip>
            </div>
            <div class="card-content">
              <div class="text-body-1 mb-3 text-center disabled-text">{{ campaigns.message }}</div>
              <v-btn text color="grey" class="pa-0 disabled-btn" disabled style="text-transform: none;">
                {{ campaigns.action }} →
              </v-btn>
            </div>
          </v-card>
        </v-col>
      </v-row>


      <v-row>

        <v-col cols="12" md="12">
          <v-card outlined>
            <v-card-title class="text-h6 font-weight-bold d-flex align-center justify-space-between">
              <span>Últimas cotações</span>
              <span class="d-flex align-center">
                <v-btn to="/app/comercial/cotacoes" text color="primary" style="text-transform:none; font-weight:500;">
                  Ver histórico ({{ totalNegotiations }} cotações)
                  <v-icon class="ml-3">mdi-arrow-right</v-icon>
                </v-btn>
              </span>
            </v-card-title>

            <div class="table-wrapper">
              <v-data-table :headers="headers" :items="recentNegotiations" :loading="negotiationsLoading"
               :items-per-page="5" :sort-by="['gridVersionCreatedOn']" :sort-desc="[true]" class="elevation-0" loading-text="Carregando pedidos..." :hide-default-footer="true" :mobile-breakpoint="0">
                
                <template v-slot:[`item.gridId`]="{ item }">
                <div class="text-center">#{{ item.gridId }}</div>
              </template>

              <template v-slot:[`item.orderStatus`]="{ item }">
                <div class="text-center">
                  <v-chip :color="getOrderStatusColor(item.orders)" :text-color="getOrderStatusTextColor(item.orders)"
                    small>
                    <strong>{{ getOrderStatusId(item.orders) }}</strong>
                  </v-chip>
                </div>
              </template>

              <template v-slot:[`item.profileLogo`]="{ item }">
                <v-img v-if="item.profileLogo" :lazy-src="item.profileLogo" max-height="41" max-width="41"
                  :src="item.profileLogo" class="logo-image">
                </v-img>
                <div class="d-flex justify-center" v-else>-</div>
              </template>

              <template v-slot:[`item.profileDisplayName`]="{ item }">
                <div class="d-flex align-center justify-center name-cell">
                  <span class="name-truncate" :title="item.profileDisplayName">{{ item.profileDisplayName }}</span>
                  <v-tooltip v-model="item.showTooltip" bottom :disabled="false" manual content-class="custom-tooltip">
                    <template v-slot:activator="{ attrs }">
                      <v-btn icon small class="ml-2" color="primary" v-bind="attrs" @click="toggleTooltip(item)">
                        <v-icon small>mdi-information-outline</v-icon>
                      </v-btn>
                    </template>
                    <div>
                      <v-card-title
                        class="text-body-1 font-weight-bold pa-3 pb-2 d-flex justify-space-between align-center">
                        <span class="mr-3">{{ item.profileDisplayName }}</span>
                        <v-btn icon x-small @click="item.showTooltip = false">
                          <v-icon small>mdi-close</v-icon>
                        </v-btn>
                      </v-card-title>
                      <v-card-text class="pa-3 pt-2">
                        <div class="text-body-2">
                          <strong>Razão Social:</strong> {{ item.profileName }}
                        </div>
                        <div class="text-body-2 mt-1">
                          <strong>CNPJ:</strong> {{ formatCNPJ(item.profileDocument) }}
                        </div>
                      </v-card-text>
                    </div>
                  </v-tooltip>
                </div>
              </template>

              <template v-slot:[`item.profileName`]="{ item }">
                <div class="text-center">{{ item.profileName }}</div>
              </template>

              <template v-slot:[`item.agencyDisplayName`]="{ item }">
                <div class="text-center">
                  <v-chip v-if="item.agencyDisplayName" color="#7F9EBB" text-color="white" small>
                    <strong>{{ item.agencyDisplayName }}</strong>
                  </v-chip>
                  <v-chip v-else color="#fb6e52" text-color="white" small>
                    <strong>Canal do Anúncio</strong>
                  </v-chip>
                </div>
              </template>

              <template v-slot:[`item.profileDocument`]="{ item }">
                <div class="text-center">{{ formatCNPJ(item.profileDocument) }}</div>
              </template>

              <template v-slot:[`item.gridVersionCreatedOn`]="{ item }">
                <div class="text-center">{{ formatDate(item.gridVersionCreatedOn) }}</div>
              </template>

              <template v-slot:[`item.gridFirstDate`]="{ item }">
                <div class="text-center">{{ formatDate(item.gridFirstDate) }}</div>
              </template>

              <template v-slot:[`item.orders`]="{ item }">
                <div class="text-center">
                  <v-tooltip bottom :disabled="false" manual v-model="item.showOrdersTooltip" content-class="custom-tooltip">
                    <template v-slot:activator="{ attrs }">
                      <v-chip color="primary" text-color="white" small v-bind="attrs"
                        @click="toggleOrdersTooltip(item)">
                        {{ item.orders.length }}
                      </v-chip>
                    </template>
                    <div>
                      <v-card-title
                        class="text-body-1 font-weight-bold pa-3 pb-2 d-flex justify-space-between align-center">
                        <span class="mr-3">Inventários</span>
                        <v-btn icon x-small @click="item.showOrdersTooltip = false">
                          <v-icon small>mdi-close</v-icon>
                        </v-btn>
                      </v-card-title>
                      <v-card-text class="pa-3 pt-2">
                        <div class="text-body-2">
                          <ul style="padding-left: 1em; margin: 0;">
                            <li v-for="order in item.orders" :key="order.orderSyncId"
                              style="font-size: 0.95em; margin-bottom: 4px;">
                              {{ order.inventoryDisplayName || 'Sem nome' }}
                            </li>
                          </ul>
                        </div>
                      </v-card-text>
                    </div>
                  </v-tooltip>
                </div>
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <div class="text-center">
                  <v-btn icon :to="`/app/comercial/cotacoes/${item.gridId}`"><v-icon small>mdi-arrow-right</v-icon></v-btn>
                </div>
              </template>
            </v-data-table>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-row>

        <v-col cols="12" md="12">
          <v-card outlined>
            <v-card-title class="text-h6 font-weight-bold d-flex align-center justify-space-between">
              <span>Portfólio de mídia</span>
              <span class="d-flex align-center">
                <v-btn to="/app/inventory/formats" text color="primary" style="text-transform:none; font-weight:500;">
                  Gerenciar inventário ({{ totalInventory }} inventários)

                  <v-icon class="ml-3">mdi-arrow-right</v-icon>
                </v-btn>

              </span>
            </v-card-title>

            <div class="table-wrapper">
              <v-data-table :headers="inventoryHeaders" :items="inventoryItems" :loading="inventoryLoading"
                :items-per-page="5" class="elevation-0" loading-text="Carregando inventários..." :hide-default-footer="true" :mobile-breakpoint="0">

                <template v-slot:[`item.logo`]="{ item }">
                <div class="d-flex justify-center">
                  <v-img v-if="item.logo" :lazy-src="item.logo" max-height="41" max-width="41" :src="item.logo"></v-img>
                  <span v-else>-</span>
                </div>
              </template>

              <template v-slot:[`item.display_name`]="{ item }">
                <div class="text-center">{{ item.display_name }}</div>
              </template>

              <template v-slot:[`item.profileAssoc`]="{ item }">
                <div class="text-center">{{ item.profile.name }}</div>
              </template>

              <template v-slot:[`item.countAsus`]="{ item }">
                <div class="text-center">{{ item.countAsus }}</div>
              </template>

              <template v-slot:[`item.status`]="{ item }">
                <div class="d-flex justify-center">
                  <v-chip :color="item.status === 'published' ? 'green' : 'red'" text-color="white" small>
                    <strong> {{ item.status === 'published' ? 'Ativo' : 'Desativado' }}</strong>
                  </v-chip>
                </div>
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <div class="d-flex justify-center">
                  <v-btn :to="`/app/inventory/formats?inventory=${encodeURIComponent(item.display_name)}`" icon small>
                    <v-icon color="primary" small>mdi-arrow-right</v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>


    <!-- White Label Modal -->
    <WhiteLabelModal v-model="showWhiteLabelModal" @close="showWhiteLabelModal = false" />

    <!-- Confirmation Dialog -->
    <v-dialog v-model="showConfirmationDialog" max-width="400">
      <v-card>
        <v-card-title class="text-h6">
          Confirmação
        </v-card-title>
        <v-card-text>
          Deseja continuar para o painel de gestão da sua loja própria?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="showConfirmationDialog = false">
            Cancelar
          </v-btn>
          <v-btn color="primary" @click="navigateToDashboard">
            Sim, continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <WelcomeBanner @close="showWelcome = false" />

  </v-container>
</template>

<script>
import http from 'axios'
import WhiteLabelModal from '@/components/dialogs/WhiteLabelModal.vue'
import WelcomeBanner from '@/interface/WelcomeBanner.vue';
import helper from '@/plugins/helper'
import { getAuth } from '@/services/authService'
export default {
  components: {
    WhiteLabelModal,
    WelcomeBanner
  },
  data() {
    return {

      get auth() {
        return getAuth()
      },
      showWelcome: false,
      pendingQuotes: {
        count: 1,
        message: 'Cotações',
        action: 'Visualizar e responder'
      },
      campaigns: {
        count: 2,
        message: 'Campanhas',
        action: 'Enviar comprobatórios'
      },

      financial: {
        firstDate: null,
        totalPis: 0,
        totalNetPrice: 0,
        loading: false
      },


      headers: [
        { text: 'Número do plano', value: 'gridId', sortable: false, width: '10%', align: 'center' },
        { text: 'Cliente', value: 'profileLogo', sortable: false, width: '8%', align: 'center' },
        { text: 'Nome', value: 'profileDisplayName', sortable: false, width: '12%', align: 'center' },
        { text: 'Agência', value: 'agencyDisplayName', sortable: false, width: '12%', align: 'center' },
        { text: 'Data da cotação', value: 'gridVersionCreatedOn', sortable: true, width: '12%', align: 'center' },
        { text: 'Formatos', value: 'orders', sortable: false, width: '8%', align: 'center' },
        { text: 'Início planejado da campanha', value: 'gridFirstDate', width: '16%', sortable: false, align: 'center' },
        { text: 'Status', value: 'orderStatus', sortable: false, width: '17%', align: 'center' },
        { text: 'Ver', value: 'actions', sortable: false, width: '5%', align: 'center' }
      ],

      inventoryHeaders: [
        { text: 'Logo', value: 'logo', sortable: false, width: '80px', align: 'center' },
        { text: 'Nome', value: 'display_name', sortable: false, align: 'center' },
        { text: 'Perfil associado', value: 'profileAssoc', sortable: false, align: 'center' },
        { text: 'Formatos cadastrados', value: 'countAsus', sortable: false, align: 'center' },
        { text: 'Status', value: 'status', sortable: false, align: 'center' },
        { text: 'Abrir', value: 'actions', sortable: false, width: '80px', align: 'center' }
      ],


      negotiations: [],

      inventoryItems: [],


      negotiationsLoading: false,
      inventoryLoading: false,


      negotiationsPage: 1,
      negotiationsPerPage: 5,
      inventoryPage: 1,
      inventoryPerPage: 5,


      totalNegotiations: 0,
      totalInventory: 0,


      negotiationsOptions: {},
      inventoryOptions: {},


      showWhiteLabelModal: false,


      showConfirmationDialog: false,


      showProfileTooltip: false
    }
  },

  watch: {
    negotiationsPage() {
      if (this.$el) {
        this.fetchTrades()
      }
    },

    negotiationsPerPage() {
      if (this.$el) {
        this.negotiationsPage = 1
        this.fetchTrades()
      }
    },

    inventoryPage() {
      if (this.$el) {
        this.fetchInventories()
      }
    },

    inventoryPerPage() {
      if (this.$el) {
        this.inventoryPage = 1
        this.fetchInventories()
      }
    }
  },

  methods: {
    getOrderStatusId(orders) {
      const statusIdList = orders.map(order => order.orderStatusId);
      const minStatusId = statusIdList.length > 0 ? Math.min(...statusIdList) : null;
      return helper.getStatusText(minStatusId);
    },

    getOrderStatusColor(orders) {
      const statusIdList = orders.map(order => order.orderStatusId);
      const minStatusId = statusIdList.length > 0 ? Math.min(...statusIdList) : null;
      return helper.getStatusColor(minStatusId);
    },

    getOrderStatusTextColor(orders) {
      const statusIdList = orders.map(order => order.orderStatusId);
      const minStatusId = statusIdList.length > 0 ? Math.min(...statusIdList) : null;
      return helper.getStatusColor(minStatusId) === '#FFFF00' ? 'black' : 'white';
    },
    profileAssoc() {
      const vehicleProfiles = Object.keys(this.auth.profiles).filter(key =>
        this.auth.profiles[key].profileTypeId === 2
      );

      if (vehicleProfiles.length > 1 && vehicleProfiles.length == 2) {
        return '(e +1 perfil associado)'
      } else if (vehicleProfiles.length > 2) {
        return `(e +${vehicleProfiles.length - 1} perfis associados)`
      } else if (vehicleProfiles.length === 0) {
        return ''
      }
    },
    getLogo() {
      if (this.auth.profile.logo.includes('lion-web-site')) {
        return this.auth.profile.logo
      } else {
        let logo = ''
        for (const key in this.auth.profiles) {
          const profile = this.auth.profiles[key]

          if (profile.logo.includes('lion-web-site')) {
            logo = profile.logo
          }
        }

        if (logo === '') {
          logo = this.auth.profile.logo
        }

        return logo
      }
    },
    formatCNPJ(cnpj) {
      if (!cnpj) return '';
      const cleanCNPJ = cnpj.toString().replace(/\D/g, '');
      if (cleanCNPJ.length !== 14) return '';
      return cleanCNPJ.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
        '$1.$2.$3/$4-$5'
      );
    },

    formatDate(dateString) {
      if (!dateString) return '';


      if (dateString.includes(' ')) {
        const [datePart] = dateString.split(' ');
        const [year, month, day] = datePart.split('-');
        return `${day}/${month}/${year}`;
      }


      if (dateString.includes('-')) {
        const [year, month, day] = dateString.split('-');
        return `${day}/${month}/${year}`;
      }

      return dateString;
    },

    toggleTooltip(item) {

      this.negotiations.forEach(negotiation => {
        if (negotiation !== item) {
          negotiation.showTooltip = false;
        }
      });

      item.showTooltip = !item.showTooltip;
    },

    toggleOrdersTooltip(item) {
      this.negotiations.forEach(negotiation => {
        if (negotiation !== item) {
          negotiation.showOrdersTooltip = false;
        }
      });

      item.showOrdersTooltip = !item.showOrdersTooltip;
    },

    toggleProfileTooltip() {
      this.showProfileTooltip = !this.showProfileTooltip;
    },

    getVehicleProfiles() {
      const vehicleProfiles = Object.keys(this.auth.profiles).filter(key =>
        this.auth.profiles[key].profileTypeId === 2
      );

      return vehicleProfiles.map(key => this.auth.profiles[key]).slice(1);
    },

    handleWhiteLabelClick() {
      if (this.auth?.whitelabel?.w?.enabled) {
        this.showConfirmationDialog = true
      } else {
        this.showWhiteLabelModal = true
      }
    },

    navigateToDashboard() {
      this.showConfirmationDialog = false
      this.$router.push('/dashboard')
    },

    async fetchTrades() {
  this.negotiationsLoading = true;

  try {
    const to = this.$moment().format('YYYY-MM-DD');

    const response = await this.$axios.get(
      `portal/orders?ignoreProfile=1&groupGrids=1&from=2015-01-01&to=${to}`
    );

    const result = response.data.data || [];
    console.log('Dados recebidos da API:', result.length, 'cotações');

    this.negotiations = result.map(item => ({
      gridId: item.gridId,
      profileLogo: item.profileLogo,
      profileDisplayName: item.profileDisplayName,
      profileName: item.profileName,
      profileDocument: item.profileDocument,
      agencyDisplayName: item.agencyDisplayName,
      gridVersionCreatedOn: item.gridVersionCreatedOn,
      gridFirstDate: item.gridFirstDate,
      orders: item.orders,
      showTooltip: false,
      showOrdersTooltip: false
    }));

    this.totalNegotiations = result.length || 0;
    console.log('Total de negociações:', this.totalNegotiations);

  } catch (error) {

    if (error && error.config) {
      const requestUrl =
        (error.config.baseURL || '') + error.config.url;

      console.error('❌ Request URL:', requestUrl);
      console.error('❌ Method:', error.config.method);
      console.error('❌ Status:', error.response && error.response.status);
    }

    console.error('Erro ao buscar negociações:', error);

    this.negotiations = [];
    this.totalNegotiations = 0;

  } finally {
    this.negotiationsLoading = false;
  }
},
    async fetchInventories() {
      this.inventoryLoading = true
      try {
        await this.$axios.get(`portal/inventory/?ignoreProfile=1`).then((data) => {
          const result = data.data.data
          const pagination = 5

          this.inventoryItems = result || []
          this.totalInventory = result ? result.length : 0

        })
      } catch (error) {
        console.error('Erro ao buscar inventários:', error)
      } finally {
        this.inventoryLoading = false
      }
    },

    async fetchFinancialData() {
      this.financial.loading = true
      try {
        const response = await this.$axios.get('financial/publisher-resume')
        
        const data = response.data.data
        
        this.financial.firstDate = data.firstDate
        this.financial.totalPis = data.totalPis || 0
        this.financial.totalNetPrice = data.totalNetPrice || 0
        
      } catch (error) {
        console.error('Erro ao buscar dados financeiros:', error)
        this.financial.firstDate = null
        this.financial.totalPis = 0
        this.financial.totalNetPrice = 0
      } finally {
        this.financial.loading = false
      }
    },

    formatCurrency(value) {
      if (!value) return 'R$ 0,00'
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(value)
    }
  },
  async mounted() {
    await this.fetchInventories()
    await this.fetchTrades()
    await this.fetchFinancialData()

    // const appStore = this.$axios.get(`portal/stats/funnel`).then((data) => {
    // })


    this.showWelcome = true
  },

  computed: {
    formattedSinceDate() {
      if (!this.auth?.user?.since) return '';

      const date = new Date(this.auth.user.since);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = String(date.getFullYear()).slice(0);

      return `${day}/${month}/${year}`;
    },
    recentNegotiations() {
      return [...this.negotiations]
        .sort((a, b) => {
          const dateA = new Date(a.gridVersionCreatedOn);
          const dateB = new Date(b.gridVersionCreatedOn);
          return dateB - dateA;
        })
        .slice(0, 5);
    }
  },
};
</script>

<style scoped>
.inventory-row:hover {
  background-color: #f5f5f5 !important;
}

.v-data-table>>>.v-data-table__wrapper {
  overflow: visible;
}

.text-caption {
  font-size: 0.75rem !important;
}

.v-chip.v-size--small {
  height: 20px;
  font-size: 10px;
  min-width: 20px;
}

.notification-card {
  position: relative;
  min-height: 170px;
  display: flex;
  flex-direction: column;
}

.notification-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  z-index: 1;
}

.wip-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  z-index: 1;
}

.disabled-card {
  opacity: 0.6;
  pointer-events: none;
  background-color: #f9f9f9 !important;
  border-color: #e0e0e0 !important;
}

.disabled-text {
  color: #9e9e9e !important;
}

.disabled-btn {
  color: #bdbdbd !important;
}

.card-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding-top: 8px;
}

.notification-card .v-btn--text:hover::before {
  opacity: 0 !important;
}

.notification-card .v-btn--text::before {
  background-color: transparent !important;
}

.logo-image {
  object-fit: contain;
}

.header-card {
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.clickable-card {
  cursor: pointer !important;
  transition: all 0.3s ease;
}

.clickable-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(32, 58, 117, 0.3) !important;
}

.white-label-text {
  color: white !important;
  font-weight: bold;
}

.white-label-btn {
  color: white !important;
}

.white-label-btn .v-btn__content {
  color: white !important;
}

.saiba-mais-text {
  color: white !important;
}

.saiba-mais-text span {
  color: white !important;
  font-size: 0.875rem;
}

.profile-tooltip-card {
  background-color: white !important;
  border: 1px solid #e0e0e0 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  border-radius: 4px !important;
}

.profile-tooltip-card .v-card__title {
  background-color: #f8f9fa !important;
  color: #333 !important;
  border-bottom: 1px solid #e0e0e0 !important;
}

.profile-tooltip-card .v-card__text {
  color: #666 !important;
}

.v-tooltip__content {
  pointer-events: auto !important;
  opacity: 1 !important;
}

.v-tooltip__content .profile-tooltip-card {
  pointer-events: auto !important;
}

.custom-tooltip {
  background-color: white !important;
  color: black !important;
  border: 1px solid #e0e0e0 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  border-radius: 4px !important;
  opacity: 1 !important;
}

.custom-tooltip .v-card {
  background-color: white !important;
  color: black !important;
}

.custom-tooltip .v-card__title {
  background-color: #f8f9fa !important;
  color: #333 !important;
  border-bottom: 1px solid #e0e0e0 !important;
}

.custom-tooltip .v-card__text {
  color: #666 !important;
}

.hover-underline:hover {
  color: #1976d2 !important;
  text-decoration: underline !important;
}


.theme--light.v-sheet {
   border-color: rgb(168, 168, 168) !important; 
}

.name-cell {
  max-width: 200px;
  min-width: 0;
}

.name-truncate {
  display: inline-block;
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.table-wrapper {
  overflow-x: visible;
}

@media (max-width: 1000px) {
  .table-wrapper {
    overflow-x: auto;
  }
}

@media (max-width: 960px) {
  .v-data-table >>> .v-data-table__mobile-row {
    min-height: auto !important;
  }
  
  .v-data-table >>> .v-data-table__mobile-row__header {
    font-weight: bold !important;
    min-width: 120px !important;
  }
  
  .v-data-table >>> .v-data-table__mobile-row__cell {
    text-align: left !important;
  }
}
   
</style>
<style>
.theme--light.v-sheet.v-sheet--outlined {
   border-color: #d2d2d2 !important; 
}
</style>